import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import { Creators as MessagesCreators } from "../ducks/messages";
import { Creators as SignupCreators } from "../ducks/signup";
import { Creators as SessionCreators } from "../ducks/session";
import { Creators as SubscriptionCreators } from "../ducks/subscription";
import api from "../../services/api";
import { siteName, siteParams } from "../../config/site";
import { formatter } from "../../services/apiResponseFormatter";

export function* signup(action) {
  const response = yield call(api.post, "v2/customers", {
    customer: { ...action.payload.customer },
    voucher: action.payload.voucher
  });

  if (response.ok) {
    yield put(SessionCreators.saveSession(response.data.token.token));
    if (action.payload.voucher) {
      yield put(SubscriptionCreators.getSubscriptionRequest());
      window.location.href = siteParams.download.url;
    } else if (siteName === "jornaleiro") {
      yield put(push("/"));
    } else {
      yield put(push("/credit-card"));
    }
  } else {
    yield put(SignupCreators.signupError());
    yield put(MessagesCreators.setMessage(formatter(response.data), "danger"));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/signup.js